import React, { Dispatch, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { cloneDeep, defaults } from "lodash";

import { PaymentProvider } from "../../../../../../../../../services/PaymentSystem";
import { ByMulty } from "../../../../../../../../../redux/reducers/OrdersPage/interface";
import LightInputModal from "../../../../../../../../../components/LightInputModal";

import Content from "./components/Content";
import Footer from "./components/Footer";

const DeactivateModal: React.FC<DeactivateModal.Props> = ({
	onClose,
	onSubmit,
	paymentProviderValue,
	...props
}) => {
	const { t } = useTranslation();
	const outerValue: ByMulty = useMemo(
		() =>
			defaults(cloneDeep(props.value ?? {}), {
				taxiServiceIds: [],
				taxiServices: [],
				companyIds: [],
				services: [],
				classes: [],
			}),
		[props.value],
	);

	const [value] = useState<Content.Value>(outerValue);

	const internalOnSubmit = useCallback(() => {
		onSubmit?.(value);
	}, [onSubmit, value]);

	return (
		<LightInputModal
			{...props}
			draggable={false}
			useDefaultFooter={false}
			title={
				t("settings.paymentSystems.modal.btns.modalDeactivate.title") ??
				""
			}
			onClose={onClose}
			onSubmit={internalOnSubmit}
		>
			<Content paymentProviderValue={paymentProviderValue} />
			<Footer onCancel={onClose} onSubmit={internalOnSubmit} />
		</LightInputModal>
	);
};

declare namespace DeactivateModal {
	type Value = Content.Value;

	interface Props
		extends Omit<
			LightInputModal.Props,
			"draggable" | "title" | "onSubmit"
		> {
		value?: Partial<Value>;
		paymentProviderValue: PaymentProvider;

		onSubmit?: Dispatch<Value>;
	}
}

export default DeactivateModal;
